"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyAlert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const ArrowButton_1 = require("../../atoms/ArrowButton/ArrowButton");
const FlatButton_1 = require("../../atoms/FlatButton/FlatButton");
function PrivacyAlert({ onBack }) {
    const { t } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'PrivacyAlert_Container', children: [(0, jsx_runtime_1.jsx)(LeftRow, { "data-e2e": 'PrivacyAlert_LeftRow', children: (0, jsx_runtime_1.jsxs)(ButtonContainer, { "data-e2e": 'PrivacyAlert_ButtonContainer', children: [(0, jsx_runtime_1.jsx)(StyledArrowButton, { direction: ArrowButton_1.Direction.Left, "data-e2e": 'PrivacyAlert_StyledArrowButton' }), (0, jsx_runtime_1.jsx)(StyledFlatButton, { onClick: onBack, "data-e2e": 'PrivacyAlert_StyledFlatButton', children: t(i18n_1.Strings.firstLaunchOnboarding.privacy.alert.back) })] }) }), (0, jsx_runtime_1.jsx)(ImageContainer, { "data-e2e": 'PrivacyAlert_ImageContainer', children: (0, jsx_runtime_1.jsx)(AlertIcon, { name: ui_1.Icons.Lock_Alert, "data-e2e": 'PrivacyAlert_AlertIcon' }) }), (0, jsx_runtime_1.jsx)(Heading, { "data-e2e": 'PrivacyAlert_Heading', children: t(i18n_1.Strings.firstLaunchOnboarding.privacy.alert.heading) }), (0, jsx_runtime_1.jsx)(Subheading, { "data-e2e": 'PrivacyAlert_Subheading', children: t(i18n_1.Strings.firstLaunchOnboarding.privacy.alert.subheading) }), (0, jsx_runtime_1.jsx)(Notice, { "data-e2e": 'PrivacyAlert_Notice', children: t(i18n_1.Strings.firstLaunchOnboarding.privacy.alert.notice) })] }));
}
exports.PrivacyAlert = PrivacyAlert;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 10px;

  ${ui_1.devicePortrait.all `
    padding-top: 32px;
  `};
`;
const ImageContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  justify-content: center;

  ${ui_1.devicePortrait.all `
    margin-top: 40%;
  `};

  ${ui_1.deviceLandscape.mobileL `
    margin-top: 15%;
  `};
  ${ui_1.device.laptop `
    margin-top: 155;
  `};
`;
const LeftRow = styled_components_1.default.div `
  padding-top: 2%;
  padding-left: 2%;
  position: absolute;
  top: 32px;
  left: 15px;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    top: 10px;
  `)}
  ${ui_1.device.tablet((0, styled_components_1.css) `
    top: 10px;
  `)}
`;
const ButtonContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-bottom: 40px;
`;
const StyledArrowButton = (0, styled_components_1.default)(ArrowButton_1.ArrowButton) `
  padding-top: 4px;
`;
const StyledFlatButton = (0, styled_components_1.default)(FlatButton_1.FlatButton) `
  text-transform: capitalize;
`;
const Heading = styled_components_1.default.h1 `
  margin: 30px 0 0 0;

  color: ${({ theme }) => theme.text};
  font-weight: 400;
  font-size: 34px;
  line-height: 1.18;
  text-align: center;
`;
const Subheading = styled_components_1.default.h2 `
  max-width: 395px;
  margin: 16px 0 50px;

  color: ${({ theme }) => theme.settings.text};
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    margin-top: 24px;
    margin-bottom: 16px;
  `)}
`;
const Notice = styled_components_1.default.h2 `
  max-width: 395px;
  margin-top: 0;
  padding-bottom: 30px;
  margin: 0 auto;

  color: ${({ theme }) => theme.text};
  font-size: 20px;
  line-height: 24px;
  text-align: center;

  ${ui_1.device.tablet `
    margin-top: 32px;
  `}

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    max-width: 230px;
  `)}

  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    max-width: none;
  `)}
`;
const AlertIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 128px;
  height: 128px;
  margin-bottom: 0;
  align-items: center;

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    margin-bottom: 24px;
  `)}
`;
